import {
  SET_THEME_COLOR,
  SET_GRADIENT_COLOR,
  SETCANCELCHEQUE,
  SETBANKSTATEMENT,
  SETEXCHANGESEGMENT,
  SETNOMINEEPROOFVALIDATE,
  REACTIVATION_PROOF,
  ACCOUNTCLOSURESCREEN
} from "./types";

export const setThemeColors = (data) => {
  return {
    type: SET_THEME_COLOR,
    data: data,
  };
};

export const setGradientColors = (data) => {
  return {
    type: SET_GRADIENT_COLOR,
    data: data,
  };
};

export const setCancelCheque = (data) => {
  return {
    type: SETCANCELCHEQUE,
    payload: data,
  };
};

export const setBankStatement = (data) => {
  return {
    type: SETBANKSTATEMENT,
    payload: data,
  };
};

export const setExchangeSegment = (data) => {
  return {
    type: SETEXCHANGESEGMENT,
    payload: data,
  };
};

export const setNomineeProofvalidate = (data) => {
  return {
    type: SETNOMINEEPROOFVALIDATE,
    payload: data,
  };
};

export const setReactivationProof = (data) => {
  return {
    type: REACTIVATION_PROOF,
    payload: data,
  };
};

export const setAccountClosureScreen = (data) => {
  return {
    type: ACCOUNTCLOSURESCREEN,
    payload: data,
  };
};
